import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-component-seperator',
  templateUrl: './component-seperator.component.html',
  styleUrls: ['./component-seperator.component.scss']
})
export class ComponentSeperatorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
